import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Authentication from "../components/PageComponent/Authentication/Authentication";

import { Loader } from "../components/atoms/Loader";
import {
  initZoho,
  fetchOrgVariablesData,
  handleAuthCheckZoho,
  handleAuthenticateZoho,
} from "../util/zohoUtil";
import ModuleSetting from "../components/PageComponent/ModuleSetting/ModuleSetting";
import RelatedList from "../components/PageComponent/RelatedList/RelatedList";
import ShowError from "../components/atoms/ShowError";
import SnackAlert from "../components/atoms/SnackAlert";
import {
  getCloseSnakData,
  getOpenSnakSuccessData,
  snackDetails,
} from "../config/otherConstant";
import { getAllConnections } from "../APICalling/ServiceAPICalling";
import { EXTENSION_IDENTIFIER } from "../config/serviceConstant";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function SettingsRoute() {
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(1);
  const [auth, setAuth] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [zApiKey, setZApiKey] = useState(null);
  const [dataCenterUrl, setDataCenterUrl] = useState(null);
  const [dataCenter, setDataCenter] = useState(null);

  const [activeUsers, setActiveUsers] = useState();
  const [currentUser, setCurrentUser] = useState();

  const [serviceApiKey, setServiceApiKey] = useState(null);
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [snack, setSnack] = useState(snackDetails);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack((prev) => getCloseSnakData(prev));
    // setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    initZoho((error, extensionData) => {
      if (error || !extensionData) {
        setLoading((prev) => false);
        return;
      }
      console.log({ extensionData });
      const {
        serviceAuth,
        orgId,
        apiKey,
        dataCenterUrl,
        zohoLoaded,
        zohoAuth,
        serviceApiKey,
        zApiKey,
        dataCenter,
        activeUsers,
        currentUser,
      } = extensionData;
      // console.log(extensionData);
      setOrgId((prev) => orgId);
      setApiKey((prev) => apiKey);
      setDataCenterUrl((prev) => dataCenterUrl);
      setDataCenter((prev) => dataCenter);

      setZApiKey((prev) => zApiKey);
      setServiceApiKey((prev) => serviceApiKey);
      setZohoLoaded((prev) => zohoLoaded);

      // setAuth((prev) => true);
      // setTabIndex((prev) => 1);

      setActiveUsers((prev) => activeUsers);
      setCurrentUser((prev) => currentUser);

      // if (serviceAuth && zohoAuth) {
      //   setAuth((prev) => true);
      //   setTabIndex((prev) => 1);
      // } else {
      //   setAuth((prev) => false);
      // }

      setLoading((prev) => false);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl) {
    return <ShowError />;
  }

  return (
    <>
      <ModuleSetting
        tabIndex={tabIndex}
        index={1}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        zApiKey={zApiKey}
        activeUsers={activeUsers}
        currentUser={currentUser}
        setSnack={setSnack}
      />

      <SnackAlert
        duration={snack?.duration}
        snackOpen={snack?.open}
        handleCloseSnack={handleCloseSnack}
        severity={snack?.severity}
        message={snack?.message}
      />
    </>
  );
}
